(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amc-collection-slider"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initialize(root){
    if(!root || root.dataset.amcSliderReady === 'true') return;
    var track = root.querySelector('.amc-cslider__track');
    var prev = root.querySelector('.amc-cslider__nav--prev');
    var next = root.querySelector('.amc-cslider__nav--next');
    if(!track) return;
    root.dataset.amcSliderReady = 'true';
    var mq = window.matchMedia('(min-width:750px)');
    function step(){ return Math.max(track.clientWidth * 0.8, 220); }
    function sync(){
      var display = mq.matches && track.scrollWidth > track.clientWidth + 4 ? 'flex' : 'none';
      if(prev) prev.style.display = display;
      if(next) next.style.display = display;
    }
    if(prev) prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    if(next) next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    window.addEventListener('resize',sync,{passive:true});
    window.addEventListener('load',sync,{once:true});
    sync();
  }
  function initializeAll(scope){
    (scope || document).querySelectorAll('.amc-cslider').forEach(initialize);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function(){initializeAll(document);},{once:true});
  else initializeAll(document);
  document.addEventListener('shopify:section:load',function(event){initializeAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amc-footer-trust-paths"] && !Shopify.designMode) return;
  try {
    
(function(){
  var footer=document.getElementById('amc-site-footer');
  if(!footer||footer.dataset.ready==='true')return;
  footer.dataset.ready='true';
  var cols=footer.querySelectorAll('details.amc-ft__col');
  var mq=window.matchMedia('(max-width: 749px)');
  function sync(){cols.forEach(function(d){if(mq.matches)d.removeAttribute('open');else d.setAttribute('open','');});}
  cols.forEach(function(d){d.querySelector('summary').addEventListener('click',function(e){if(!mq.matches)e.preventDefault();});});
  sync();
  if(mq.addEventListener)mq.addEventListener('change',sync);
  var form=footer.querySelector('.amc-ft__form');
  if(form){
    var b=form.querySelector('[data-amc-newsletter-submit]');
    var label=form.querySelector('[data-amc-newsletter-label]');
    var progress=form.querySelector('[data-amc-newsletter-progress]');
    var resetTimer;
    function reset(){
      if(b){b.classList.remove('is-submitting');b.removeAttribute('aria-busy');}
      if(label)label.textContent='Subscribe';
      if(progress)progress.textContent='';
      clearTimeout(resetTimer);
    }
    var okMsg='<strong>Signup received.</strong> Check your inbox for any confirmation step.';
    function show(kind,html){
      var m=form.querySelector('.amc-ft__msg');
      if(!m){m=document.createElement('p');progress.insertAdjacentElement('afterend',m);}
      m.className='amc-ft__msg amc-ft__msg--'+kind;m.setAttribute('role',kind==='ok'?'status':'alert');m.tabIndex=-1;m.innerHTML=html;
    }
    function klaviyo(email){
      return fetch('https://a.klaviyo.com/client/subscriptions?company_id=WiCv5J',{method:'POST',headers:{'Content-Type':'application/vnd.api+json','revision':'2024-10-15'},body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Footer signup',profile:{data:{type:'profile',attributes:{email:email}}}},relationships:{list:{data:{type:'list',id:'RBzpq9'}}}}})}).then(function(response){
        if(!response.ok)throw new Error('Subscription was not accepted');
      });
    }
    /* Shopify's spam protection posts this form itself, so the post goes into a hidden frame:
       the page never reloads, and the result is read back from the frame (same origin). */
    var sink=document.createElement('iframe');sink.name='amcFtSink';sink.title='Newsletter signup';sink.hidden=true;sink.tabIndex=-1;sink.setAttribute('aria-hidden','true');
    document.body.appendChild(sink);form.target='amcFtSink';
    var pending=false;
    var pendingEmail='';
    var attempt=0;
    function finish(kind,html){
      pending=false;
      pendingEmail='';
      reset();
      if(b)b.disabled=false;
      show(kind,html);
    }
    sink.addEventListener('load',function(){
      if(!pending||sink.dataset.amcChecking==='true')return;
      var href='',doc=null;
      try{href=sink.contentWindow.location.href;doc=sink.contentDocument;}catch(e){
        finish('error','We could not confirm your signup. Please try again.');
        return;
      }
      if(!href||href==='about:blank')return;
      var result;
      try{result=new URL(href,window.location.origin);}catch(e){
        finish('error','We could not confirm your signup. Please try again.');
        return;
      }
      if(result.origin!==window.location.origin){
        finish('error','We could not confirm your signup. Please try again.');
        return;
      }
      if(/^\/challenge(?:\/|$)/.test(result.pathname)){
        pending=false;
        reset();
        window.location.assign(href);
        return;
      }
      var accepted=result.searchParams.get('customer_posted')==='true';
      var bad=doc&&doc.querySelector('.amc-ft__msg--error,.form__message--error,.errors');
      if(!accepted||bad){
        finish('error','Your signup was not confirmed. Please check your email address and try again.');
        return;
      }
      var currentAttempt=attempt;
      var email=pendingEmail;
      sink.dataset.amcChecking='true';
      if(progress)progress.textContent='Saving your email preferences…';
      klaviyo(email).then(function(){
        if(currentAttempt!==attempt||!pending)return;
        finish('ok',okMsg);
        var input=form.querySelector('input[name="contact[email]"]');
        if(input&&input.value.trim()===email)input.value='';
        if(b)b.classList.add('is-success');
        if(label)label.innerHTML='<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12 4 4L19 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Received</span>';
      }).catch(function(){
        if(currentAttempt!==attempt||!pending)return;
        finish('error','Your signup was saved, but we could not confirm email updates. Please try again.');
      }).finally(function(){
        if(currentAttempt===attempt)delete sink.dataset.amcChecking;
      });
    });
    form.addEventListener('submit',function(event){
      if(!form.checkValidity()||pending){event.preventDefault();return;}
      pending=true;
      var em=form.querySelector('input[name="contact[email]"]');
      pendingEmail=(em&&em.value||'').trim();
      attempt+=1;
      delete sink.dataset.amcChecking;
      if(b){b.classList.remove('is-success');b.classList.add('is-submitting');b.setAttribute('aria-busy','true');}
      if(label)label.textContent='Subscribing…';
      if(progress)progress.textContent='';
      var oldMessage=form.querySelector('.amc-ft__msg');
      if(oldMessage)oldMessage.remove();
      clearTimeout(resetTimer);
      resetTimer=setTimeout(function(){
        if(pending){
          attempt+=1;
          delete sink.dataset.amcChecking;
          finish('error','We could not confirm your signup. Please try again.');
        }
      },20000);
    },true);
    window.addEventListener('pageshow',reset);
    var msg=form.querySelector('.amc-ft__msg[role="status"],.amc-ft__msg[role="alert"]');
    if(msg)requestAnimationFrame(function(){msg.scrollIntoView({block:'center'});msg.focus({preventScroll:true});});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();
})();
